import React from 'react';

import { Content as CommonContent } from '../common/Types.jsx';
import { withPageHandler } from '../common/Component.jsx';
import { withBlockRendering } from '../utility/Config.jsx';
import Container from '../common/Container.jsx';
import { Component as ItemMetaComponent, TypeConfig as ItemMetaTypeConfig } from './ItemMeta.jsx';
import CellItemContainer from '../common/CellItemContainer.jsx';
import * as CellItemImage from '../common/CellItemImage.jsx';
import Name from '../utility/Name.jsx';
import Token from '../utility/Token.jsx';
import { default as _TypeConfig } from '../common/TypeConfig.jsx';
import Utilities from '../utility/Utilities.jsx';

const Blocks = {
    get: (group, data) => [
        ...CommonContent.get(group),
        {
            id: Name.Block.Inventory.Image,
            component: CellItemImage.Component,
            config: {
                Block: CellItemImage.TypeConfig.panel.block(),
                Style: CellItemImage.TypeConfig.panel.style()
            },
            display: 'Item Image',
            group,
            image: ''
        },
        {
            id: Name.Block.Inventory.Meta,
            component: ItemMetaComponent,
            config: {
                Block: ItemMetaTypeConfig.panel.block(),
                Style: ItemMetaTypeConfig.panel.style(),
                Description: ItemMetaTypeConfig.panel.description(),
                Label: ItemMetaTypeConfig.panel.label(),
                Value: ItemMetaTypeConfig.panel.value(data)
            },
            display: 'Item Meta',
            group,
            image: ''
        }
    ]
};

function _ItemContainer(props) {
    const config = props.config || {};
    const blockConfig = config.config && config.config.Block || {};
    const visibility = props.config && props.config.config && props.config.config.Visibility
    const visibilityHash = Utilities.Config.getVisibilityHash({ block: config });

    let columnSpacing, rowSpacing;
    const options = Utilities.Config.getStyle(blockConfig, undefined, (name, value, obj) => {
        switch (name) {
            case 'columnCount':
            case 'itemsPerPage':
                let temp = parseInt(value, 10);
                if (!isNaN(temp) && temp > 0) {
                    obj[name] = temp;
                }
                return true;
            case 'columnSpacing':
                columnSpacing = value;
                return true;
            case 'rowSpacing':
                rowSpacing = value;
                return true;
        }
    })
    options.columnCount = options.columnCount || 2;
    options.itemsPerPage = options.itemsPerPage || 4;
    if (options.itemsPerPage < options.columnCount) {
        options.columnCount = options.itemsPerPage;
    }
    options.rowCount = Math.ceil(options.itemsPerPage / options.columnCount);
    const inventory = props.data && props.data.Inventory || [];
    let inventoryLength = inventory.length;
    if (props.builder && inventoryLength > options.itemsPerPage) {
        inventoryLength = options.itemsPerPage;
    }
    const pageCount = Math.ceil(inventoryLength / options.itemsPerPage);
    let contentConfig;
    if (blockConfig.design && blockConfig.design.Config && blockConfig.design.Config.blocks && blockConfig.design.Config.blocks.length > 0) {
        contentConfig = blockConfig.design;
    }
    const spacingForItem = (index, count, spacing) => {
        if (spacing && spacing.value && spacing.unit) {
            const spacingFraction = parseFloat(spacing.value / count);
            const modulo = index % count;
            return {
                paddingLeft: `${parseFloat(modulo * spacingFraction)}${spacing.unit}`,
                paddingRight: `${parseFloat((count - modulo - 1) * spacingFraction)}${spacing.unit}`
            };
        }
    }
    const columnStyle = [];
    for (let i = 0; i < options.columnCount; i++) {
        let _style = { verticalAlign: options[`align-col${i + 1}`] || 'middle' };
        const temp = spacingForItem(i, options.columnCount, columnSpacing);
        if (temp) {
            _style = { ..._style, ...temp };
        }
        columnStyle.push(_style);
    }
    const containerForRow = (rowIndex, rowData, rowSpacing, options) => {
        const _columnCount = Math.min(rowData.length, options.columnCount);
        const width = `${100.0 / (_columnCount || 1)}%`;
        const componentData = rowData.map((d, i) => {
            let style = { width };
            if (_columnCount == options.columnCount) {
                if (columnStyle[i]) {
                    style = { ...style, ...columnStyle[i] }
                }
            } else {
                const temp = spacingForItem(i, _columnCount);
                if (temp) {
                    style = { ...style, ...temp }
                }
            }
            return (
                <td key={i} style={style}>
                    <ItemContentContainer
                        config={contentConfig}
                        data={props.data}
                        itemData={d}
                        kit={props.kit}
                        serverSide={props.serverSide}
                        visibility={visibility}
                        visibilityHash={visibilityHash} />
                </td>
            )
        })
        let style;
        const spacing = spacingForItem(rowIndex, options.rowCount, rowSpacing);
        if (spacing) {
            style = { paddingBottom: spacing.paddingRight, paddingTop: spacing.paddingLeft };
        }
        return (
            <table key={rowIndex} border="0" cellPadding="0" cellSpacing="0" style={style} width="100%">
                <tbody>
                    <tr>{componentData}</tr>
                </tbody>
            </table>
        )
    }
    const containerForPage = (index, rows, pageHeader, pageCount) => {
        let pageClassName;
        if (index < pageCount - 1) {
            pageClassName = 'pageBreakAfterAlways';
        }
        return props.onPageForItem(index, rows, pageHeader, pageClassName);
    }
    const content = [];
    const pageHeader = props.onPageHeader();
    let componentData = [];
    let rows = [];
    for (let i = 0; i < inventoryLength; i++) {
        if (i > 0 && i % options.itemsPerPage == 0) {
            // End of current page
            if (componentData.length > 0) {
                // Add remaining row content
                rows.push(containerForRow(rows.length, componentData, rowSpacing, options));
                componentData = [];
            }

            // Create page for row content
            content.push(containerForPage(content.length, rows, pageHeader, pageCount));
            rows = [];
        }

        // Add row content
        componentData.push(inventory[i]);
        if (componentData.length >= options.columnCount) {
            // Add row content to current page content
            rows.push(containerForRow(rows.length, componentData, rowSpacing, options));
            componentData = [];
        }
    }
    if (componentData.length > 0) {
        // Add remaining row content
        rows.push(containerForRow(rows.length, componentData, rowSpacing, options));
    }
    if (rows.length > 0) {
        // Create remaining page for row content
        content.push(containerForPage(content.length, rows, pageHeader, pageCount));
    }
    return (
        <Container
            builder={props.builder}
            className={props.className}
            config={props.config}
            dataType="layout"
            onClick={props.onClick}
            onDragEnter={props.onDragEnter}
            onDragStart={props.onDragStart}>
            <tr>
                <td>
                    {content}
                </td>
                {
                    props.builder &&
                    <td>
                        {
                            !contentConfig &&
                            Utilities.Builder.emptyBlockPlaceholder()
                        }
                        {Utilities.Builder.dragOutline()}
                    </td>
                }
            </tr>
        </Container>
    );
}
const ItemContainer = withPageHandler(_ItemContainer);

const ItemContentContainer = withBlockRendering(CellItemContainer, Blocks.get());

const TypeConfig = {
    defaultDesign: (data) => ({
        "Config": {
            "blocks": [
                {
                    "config": {
                        "Block": {
                            "maxHeight": {
                                "unit": "px",
                                "value": "300"
                            },
                            "maxWidth": {
                                "unit": "px",
                                "value": ""
                            }
                        },
                        "Style": {
                            "paddingBottom": {
                                "unit": "px",
                                "value": "20"
                            },
                            "textAlign": "center"
                        }
                    },
                    "id": `${Name.Block.Inventory.Image}-${new Date().getTime()}`,
                    "type": {
                        "value": Name.Block.Inventory.Image
                    }
                },
                {
                    "config": {
                        "Block": {
                            "count": "1",
                            "displayType": "columns",
                            "rowCount": "1"
                        },
                        "Style": {},
                        "Description": {},
                        "Label": {},
                        "Value": {
                            "design": ItemMetaTypeConfig.defaultDesign(data)
                        }
                    },
                    "id": `${Name.Block.Inventory.Meta}-1-${new Date().getTime()}`,
                    "type": {
                        "value": Name.Block.Inventory.Meta
                    }
                },
                {
                    "config": {
                        "Block": {
                            "count": "1",
                            "displayType": "columns",
                            "rowCount": "1"
                        },
                        "Style": {
                            "paddingRight": {
                                "unit": "px",
                                "value": "20"
                            }
                        },
                        "Description": {},
                        "Label": {},
                        "Value": {
                            "design": ItemMetaTypeConfig.defaultDesignSku()
                        }
                    },
                    "id": `${Name.Block.Inventory.Meta}-2-${new Date().getTime()}`,
                    "type": {
                        "value": Name.Block.Inventory.Meta
                    }
                }
            ]
        },
        "Type": Name.Content.MosaicItem
    }),
    dropdown: {
        alignment: () => [
            { display: 'Top', value: 'top' },
            { display: 'Middle', value: 'middle' },
            { display: 'Bottom', value: 'bottom' }
        ]
    },
    panel: {
        block: () => {
            const group = 'block';
            return {
                group,
                label: 'Design',
                options: [
                    {
                        display: 'Edit Item Content',
                        fullWidth: true,
                        group,
                        offsetTop: true,
                        type: 'edit-button',
                        value: {
                            keyPath: ['Block', 'design'],
                            name: Name.Content.MosaicItem
                        }
                    },
                    {
                        fullWidth: true,
                        group,
                        type: 'info',
                        value: '* Items Per Page is best-effort, so some items may appear on a separate page'
                    },
                    {
                        display: 'Column Count',
                        group,
                        name: 'columnCount',
                        options: [
                            { display: '2', value: '2' },
                            { display: '3', value: '3' },
                            { display: '4', value: '4' }
                        ],
                        type: 'dropdown',
                        value: '2'
                    },
                    {
                        display: 'Items Per Page',
                        group,
                        name: 'itemsPerPage',
                        options: [
                            { display: '2', value: '2' },
                            { display: '3', value: '3' },
                            { display: '4', value: '4' },
                            { display: '5', value: '5' },
                            { display: '6', value: '6' },
                            { display: '7', value: '7' },
                            { display: '8', value: '8' },
                        ],
                        type: 'dropdown',
                        value: '4'
                    },
                    {
                        display: 'Column Spacing',
                        fullWidth: true,
                        group,
                        name: 'columnSpacing',
                        options: _TypeConfig.dropdown.measurement(),
                        type: 'measurement-slider',
                        value: { 
                            'unit': 'px',
                            'value': '20'
                        }
                    },
                    {
                        display: 'Row Spacing',
                        fullWidth: true,
                        group,
                        name: 'rowSpacing',
                        options: _TypeConfig.dropdown.measurement(),
                        type: 'measurement-slider',
                        value: { 
                            'unit': 'px',
                            'value': '20'
                        }
                    },
                    {
                        display: 'Column 1 Alignment',
                        group,
                        name: 'align-col1',
                        options: TypeConfig.dropdown.alignment(),
                        type: 'dropdown',
                        value: 'middle'
                    },
                    {
                        display: 'Column 2 Alignment',
                        group,
                        name: 'align-col2',
                        options: TypeConfig.dropdown.alignment(),
                        type: 'dropdown',
                        value: 'middle'
                    },
                    {
                        display: 'Column 3 Alignment',
                        group,
                        name: 'align-col3',
                        options: TypeConfig.dropdown.alignment(),
                        type: 'dropdown',
                        value: 'middle',
                        visible: (config) => config.Block && (config.Block.columnCount == '3' || config.Block.columnCount == '4')
                    },
                    {
                        display: 'Column 4 Alignment',
                        group,
                        name: 'align-col4',
                        options: TypeConfig.dropdown.alignment(),
                        type: 'dropdown',
                        value: 'middle',
                        visible: (config) => config.Block && config.Block.columnCount == '4'
                    }
                ]
            }
        },
        style: () => _TypeConfig.panel.layoutStyle('style', undefined, {}, undefined, {}),
        visibility: () => {
            return {
                expanded: false,
                label: 'Visibility',
                options: [
                    { display: 'Edition Info', name: Token.Inventory.Edition, type: 'checkbox', value: true, configurableDuringExport: (_, config) => Token.isTokenPresent(Token.Inventory.Edition, config, Name.Block.Inventory.Meta) },
                    { display: 'Created Date', name: Token.Date, type: 'checkbox', value: true, configurableDuringExport: (_, config) => Token.isTokenPresent(Token.Date, config, Name.Block.Inventory.Meta) },
                    { display: 'Medium', name: Token.Inventory.Medium, type: 'checkbox', value: true, configurableDuringExport: (_, config) => Token.isTokenPresent(Token.Inventory.Medium, config, Name.Block.Inventory.Meta) },
                    { display: 'Signature Placement', name: Token.Inventory.Signature, type: 'checkbox', value: true, configurableDuringExport: (_, config) => Token.isTokenPresent(Token.Inventory.Signature, config, Name.Block.Inventory.Meta) },
                    { display: 'Dimensions', name: Token.Inventory.Dimensions, type: 'checkbox', value: true, configurableDuringExport: (_, config) => Token.isTokenPresent(Token.Inventory.Dimensions, config, Name.Block.Inventory.Meta) },
                    { display: 'Alternate Dimensions', name: Token.Inventory.AlternateDimensions, type: 'checkbox', value: true, configurableDuringExport: (_, config) => Token.isTokenPresent(Token.Inventory.AlternateDimensions, config, Name.Block.Inventory.Meta) },
                    { display: 'Framing', name: Token.Inventory.Framed, type: 'checkbox', value: true, configurableDuringExport: (_, config) => Token.isTokenPresent(Token.Inventory.Framed, config, Name.Block.Inventory.Meta) },
                    { display: 'Inventory Number', name: Token.Inventory.Number, type: 'checkbox', value: true, configurableDuringExport: (_, config) => Token.isTokenPresent(Token.Inventory.Number, config, Name.Block.Inventory.Meta) },
                    { display: 'SKU', name: Token.Inventory.SKU, type: 'checkbox', value: true, configurableDuringExport: (_, config) => Token.isTokenPresent(Token.Inventory.SKU, config, Name.Block.Inventory.Meta) },
                    { display: 'Location', name: Token.Inventory.Location, type: 'checkbox', value: true, configurableDuringExport: (_, config) => Token.isTokenPresent(Token.Inventory.Location, config, Name.Block.Inventory.Meta) },
                    { display: 'Retail Price', name: Token.Inventory.Price, type: 'checkbox', value: true, configurableDuringExport: (_, config) => Token.isTokenPresent(Token.Inventory.Price, config, Name.Block.Inventory.Meta) },
                    { display: 'Alternate Prices', name: Token.Inventory.AlternatePrices, type: 'checkbox', value: true, configurableDuringExport: (_, config) => Token.isTokenPresent(Token.Inventory.AlternatePrices, config, Name.Block.Inventory.Meta) },
                    { display: 'Price Override', name: Token.Inventory.DisplayPrice, type: 'checkbox', value: true, configurableDuringExport: (_, config) => Token.isTokenPresent(Token.Inventory.DisplayPrice, config, Name.Block.Inventory.Meta) }
                ],
                visible: () => false
            };
        }
    }
}

export {
    Blocks,
    ItemContentContainer as ContentContainer,
    ItemContainer as Component,
    TypeConfig
};